<nz-form-item [class.active]="hasValue || isFieldFocusing || (hasValue && formControl.valid)" class="korviu-input-box">
  @if (label) {
    <label class="paragraph-medium regular korviu-input-label">{{ label }}</label>
  }
  <nz-date-picker
    nzSize="large"
    class="korviu-input"
    [nzMode]="mode"
    [nzFormat]="dateFormat()"
    [nzDefaultPickerValue]="defaultPickerValue()"
    [formControl]="formControl"
    [nzPlaceHolder]="label"
    [nzDisabledDate]="disabledDate"
    (nzOnOpenChange)="onCalendarOpenChange($event)"
    (keyup)="onDateInputKeyup($event)"
  ></nz-date-picker>

  <ng-template #suffixIcon>
    <i nz-icon nzType="calendar" class="flex justify-end items-center">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
          d="M14.7917 2.5C16.2874 2.5 17.5 3.71256 17.5 5.20833V14.7917C17.5 16.2874 16.2874 17.5 14.7917 17.5H5.20833C3.71256 17.5 2.5 16.2874 2.5 14.7917V5.20833C2.5 3.71256 3.71256 2.5 5.20833 2.5H14.7917ZM16.25 7.08333H3.75V14.7917C3.75 15.5971 4.40292 16.25 5.20833 16.25H14.7917C15.5971 16.25 16.25 15.5971 16.25 14.7917V7.08333ZM6.45833 12.0833C7.03363 12.0833 7.5 12.5497 7.5 13.125C7.5 13.7003 7.03363 14.1667 6.45833 14.1667C5.88303 14.1667 5.41667 13.7003 5.41667 13.125C5.41667 12.5497 5.88303 12.0833 6.45833 12.0833ZM10 12.0833C10.5753 12.0833 11.0417 12.5497 11.0417 13.125C11.0417 13.7003 10.5753 14.1667 10 14.1667C9.42467 14.1667 8.95833 13.7003 8.95833 13.125C8.95833 12.5497 9.42467 12.0833 10 12.0833ZM6.45833 8.75C7.03363 8.75 7.5 9.21633 7.5 9.79167C7.5 10.367 7.03363 10.8333 6.45833 10.8333C5.88303 10.8333 5.41667 10.367 5.41667 9.79167C5.41667 9.21633 5.88303 8.75 6.45833 8.75ZM10 8.75C10.5753 8.75 11.0417 9.21633 11.0417 9.79167C11.0417 10.367 10.5753 10.8333 10 10.8333C9.42467 10.8333 8.95833 10.367 8.95833 9.79167C8.95833 9.21633 9.42467 8.75 10 8.75ZM13.5417 8.75C14.117 8.75 14.5833 9.21633 14.5833 9.79167C14.5833 10.367 14.117 10.8333 13.5417 10.8333C12.9663 10.8333 12.5 10.367 12.5 9.79167C12.5 9.21633 12.9663 8.75 13.5417 8.75ZM14.7917 3.75H5.20833C4.40292 3.75 3.75 4.40292 3.75 5.20833V5.83333H16.25V5.20833C16.25 4.40292 15.5971 3.75 14.7917 3.75Z"
          fill="#9898B3"
        />
      </svg>
    </i>
  </ng-template>
</nz-form-item>
